module.exports = __webpack_public_path__ + "img/user-pic.cafcd396.svg";